import Vue from 'vue'
import Router from 'vue-router'

const Home = r => require.ensure([], () => r(require('../views/home')), 'home')
const Identification = r => require.ensure([], () => r(require('../views/identification')), 'Identification')
const Code = r => require.ensure([], () => r(require('../views/code')), 'Code')
const Rule = r => require.ensure([], () => r(require('../views/rule')), 'Rule')
const Award = r => require.ensure([], () => r(require('../views/award')), 'Award')

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/identification',
      name: 'Identification',
      component: Identification
    },
    {
      path: '/code',
      name: 'Code',
      component: Code
    },
    {
      path: '/rule',
      name: 'Rule',
      component: Rule
    },
    {
      path: '/award',
      name: 'Award',
      component: Award
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js